import React from 'react'
import { withIcon } from '../../withIcon'

function ThumbsDownIcon (props) {
  const {
    size = '16px',
    color = 'currentColor',
    filled = false,
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path d="M11.5 9L8.8 13.4C8.6 13.7 8.3 14 7.9 14C7.1 14 6.5 13.4 6.5 12.6V10H3.4C2.6 10 2 9.2 2.2 8.4L3.4 3.4C3.6 2.6 4.3 2 5.1 2H9.5C10 2 10.5 2.2 10.9 2.6L11.5 3.2V9Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={filled ? color : 'none'} />
      <path d="M14 9H12V2H14V9Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={filled ? color : 'none'} />
    </svg>
  )
}

export default withIcon(ThumbsDownIcon)
